import request from "@/utils/http"
import store from "@/store"
import * as TemplateApi from "@/api/public/template"

export function getBatchSheetBtnList(sheetId) {
  return request.get(`/sheet/getBatchSheetBtnList`, { params: { sheetId } }).commonDeal()
}

export function batchClickSheetBtn(data) {
  return request.post(`/sheet/batchClickSheetBtn`, data).commonDeal()
}

export function batchUpdateSheetData(data) {
  return request.post(`/sheet/batchUpdateSheetData`, data).commonDeal()
}

export function batchDeleteData(data) {
  return request.post(`/sheet/batchDeleteData`, data).commonDeal()
}

export function batchUpdateParticipant(data) {
  return request.post(`/sheet/batchUpdateParticipant`, data).commonDeal()
}

export function batchUpdateOwner(data, newOwnerId, partFlag) {
  return request
    .post(`/sheet/batchUpdateOwner`, data, { params: { newOwnerId, partFlag } })
    .commonDeal()
}

export function batchLockSheetData(data, lockFlag) {
  return request.post(`/sheet/batchLockSheetData`, data, { params: { lockFlag } }).commonDeal()
}

export function batchPrint(data, templateId) {
  return request.post(`/sheet/batchPrint`, data, { params: { templateId } }).commonDeal()
}

export function getSheetDataBakList(data, appId) {
  return request.post(`/sheet/getSheetDataBakList`, data, { params: { appId } }).commonDeal()
}

export function getSheetDataBak(bakId, appId) {
  return request.get(`/sheet/getSheetDataBak`, { params: { bakId, appId } }).commonDeal()
}

export function deleteSheetDataBak(bakIds, appId, all) {
  return request.post(`/sheet/deleteSheetDataBak`, bakIds, { params: { appId, all } }).commonDeal()
}

export function restoreSheetDataBak(bakIds, replaceWhenSingle, appId) {
  return request
    .post(`/sheet/restoreSheetDataBak`, bakIds, { params: { replaceWhenSingle, appId } })
    .commonDeal()
}

export function getViewSummary(sheetId) {
  if (store.getters.isTemplateMode) {
    return TemplateApi.getViewSummary(sheetId)
  }
  return request.get(`/sheet/getViewSummary`, { params: { sheetId } }).commonDeal()
}
